import * as actions from './actionsTypes';

const initialData = {
  loadingDoc: false,
  loadingDocs: false,
  loadingAreas: false,
  loadingCarpetas: false,
  loaderSubNiveles: false,
  saveDocsLoading: false,
  docs: [],
  doc: {},
  formErrors: '',
  error: '',
  areas: [],
  carpetas: [],
  subNiveles: null,
  areasError: '',
  carpetasError: '',
  docError: '',
  subNivelesError: '' 
}

export default function gestorDocumentalReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADER_VIEW_DOCUMENT:
      return {...state, loadingDoc: action.payload}
    case actions.LOADER_GESTOR_DOCUMENTAL_DATA:
      return {...state, loadingDocs: action.payload}
    case actions.LOADER_GESTOR_DOCUMENTAL_AREAS:
      return {...state, loadingAreas: action.payload}
    case actions.LOADER_SUBNIVELES:
      return {...state, loaderSubNiveles: action.payload}
    case actions.LOADER_GESTOR_DOCUMENTAL_CARPETAS:
      return {...state, loadingCarpetas: action.payload}
    case actions.LOADER_GESTOR_DOCUMENTAL_FORM_SEND_DATA:
      return {...state, saveDocsLoading: action.payload}
    case actions.VIEW_DOC:
      return {...state, doc: action.payload}
    case actions.GET_GESTOR_DOCUMENTAL_DATA:
      return {...state, docs: action.payload}
    case actions.GET_GESTOR_DOCUMENTAL_AREAS:
      return {...state, areas: action.payload}
    case actions.GET_GESTOR_DOCUMENTAL_CARPETAS:
      return {...state, carpetas: action.payload}
    case actions.GET_SUBNIVELES:
      return {...state, subNiveles: action.payload}
    case actions.GESTOR_DOCUMENTAL_ERROR_GET_DATA:
      return {...state, error: action.payload}
    case actions.GESTOR_DOCUMENTAL_AREAS_ERROR:
      return {...state, areasError: action.payload}
    case actions.GESTOR_DOCUMENTAL_CARPETAS_ERROR:
      return {...state, carpetasError: action.payload}
    case actions.GESTOR_DOCUMENTAL_FORM_SEND_DATA_ERROR:
      return {...state, formErrors: action.payload}
    case actions.VIEW_DOC_ERROR:
      return {...state, docError: action.payload}
    case actions.GET_SUBNIVELES_ERROR:
      return {...state, subNivelesError: action.payload}
    default:
      return state
  }
}